'use client'

import { Select, SelectItem } from '@heroui/react'
import { useMemo, useState } from 'react'

export default function FormSelect({
  name,
  label,
  options,
  defaultValue,
  form,
  className,
  isRequired,
  onChange,
}: {
  name: string
  label: string
  options: Array<{ key: string; label: string }>
  defaultValue?: string
  form?: string
  className?: string
  isRequired?: boolean
  onChange?: (value: string) => void
}) {
  const initial = useMemo(() => (defaultValue ? new Set([defaultValue]) : new Set<string>()), [defaultValue])
  const [selectedKeys, setSelectedKeys] = useState<Set<string>>(initial)
  const value = Array.from(selectedKeys)[0] || ''

  const handleSelectionChange = (keys: any) => {
    const newValue = Array.from(keys)[0] as string || ''
    setSelectedKeys(new Set(keys))
    if (onChange) {
      onChange(newValue)
    }
  }

  return (
    <>
      <Select 
        label={label} 
        selectedKeys={selectedKeys} 
        onSelectionChange={handleSelectionChange} 
        className={className}
        isRequired={isRequired}
      >
        {options.map((opt) => (
          <SelectItem key={opt.key}>
            {opt.label}
          </SelectItem>
        ))}
      </Select>
      <input type="hidden" name={name} value={value} form={form} />
    </>
  )
}


